/**
 * @flow
 * @relayHash 43bdfd346ba12712dd36296cffb361fa
 */

/* eslint-disable */

'use strict'

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RewardsDeleteGiveawayInput = {|
  period: string,
  clientMutationId?: ?string,
|};
export type GiveawaysDeleteGiveawayMutationVariables = {|
  input: RewardsDeleteGiveawayInput
|};
export type GiveawaysDeleteGiveawayMutationResponse = {|
  +rewardsDeleteGiveaway: ?{|
    +success: ?boolean,
    +errors: ?$ReadOnlyArray<?{|
      +statusCode: ?number,
      +message: ?string,
      +meta: ?any,
      +errorCode: ?string,
      +code: ?number,
    |}>,
  |}
|};
export type GiveawaysDeleteGiveawayMutation = {|
  variables: GiveawaysDeleteGiveawayMutationVariables,
  response: GiveawaysDeleteGiveawayMutationResponse,
|};
*/

/*
mutation GiveawaysDeleteGiveawayMutation(
  $input: RewardsDeleteGiveawayInput!
) {
  rewardsDeleteGiveaway(input: $input) {
    success
    errors {
      statusCode
      message
      meta
      errorCode
      code
    }
  }
}
*/

const node /*: ConcreteRequest*/ = (function() {
    var v0 = [
            {
                kind: 'LocalArgument',
                name: 'input',
                type: 'RewardsDeleteGiveawayInput!',
                defaultValue: null,
            },
        ],
        v1 = [
            {
                kind: 'LinkedField',
                alias: null,
                name: 'rewardsDeleteGiveaway',
                storageKey: null,
                args: [
                    {
                        kind: 'Variable',
                        name: 'input',
                        variableName: 'input',
                    },
                ],
                concreteType: 'RewardsDeleteGiveawayPayload',
                plural: false,
                selections: [
                    {
                        kind: 'ScalarField',
                        alias: null,
                        name: 'success',
                        args: null,
                        storageKey: null,
                    },
                    {
                        kind: 'LinkedField',
                        alias: null,
                        name: 'errors',
                        storageKey: null,
                        args: null,
                        concreteType: 'RewardsError',
                        plural: true,
                        selections: [
                            {
                                kind: 'ScalarField',
                                alias: null,
                                name: 'statusCode',
                                args: null,
                                storageKey: null,
                            },
                            {
                                kind: 'ScalarField',
                                alias: null,
                                name: 'message',
                                args: null,
                                storageKey: null,
                            },
                            {
                                kind: 'ScalarField',
                                alias: null,
                                name: 'meta',
                                args: null,
                                storageKey: null,
                            },
                            {
                                kind: 'ScalarField',
                                alias: null,
                                name: 'errorCode',
                                args: null,
                                storageKey: null,
                            },
                            {
                                kind: 'ScalarField',
                                alias: null,
                                name: 'code',
                                args: null,
                                storageKey: null,
                            },
                        ],
                    },
                ],
            },
        ]
    return {
        kind: 'Request',
        fragment: {
            kind: 'Fragment',
            name: 'GiveawaysDeleteGiveawayMutation',
            type: 'Mutation',
            metadata: null,
            argumentDefinitions: (v0 /*: any*/),
            selections: (v1 /*: any*/),
        },
        operation: {
            kind: 'Operation',
            name: 'GiveawaysDeleteGiveawayMutation',
            argumentDefinitions: (v0 /*: any*/),
            selections: (v1 /*: any*/),
        },
        params: {
            operationKind: 'mutation',
            name: 'GiveawaysDeleteGiveawayMutation',
            id: null,
            text:
                'mutation GiveawaysDeleteGiveawayMutation(\n  $input: RewardsDeleteGiveawayInput!\n) {\n  rewardsDeleteGiveaway(input: $input) {\n    success\n    errors {\n      statusCode\n      message\n      meta\n      errorCode\n      code\n    }\n  }\n}\n',
            metadata: {},
        },
    }
})()
// prettier-ignore
;(node/*: any*/).hash = '87215b305a69b315a35695c8276c794c';
module.exports = node
